module.exports = __webpack_public_path__ + "static/media/facebook.2806bbf5.svg";